<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-job`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 5a2 2 0 012 2v4h7a2 2 0 012 2v28a2 2 0 01-2 2H6a2 2 0 01-2-2V13a2 2 0 012-2h7V7a2 2 0 012-2h18zM13 25H8v14h32V25h-5v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H17v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1zm27-10H8v6h5v-1a1 1 0 011-1h2a1 1 0 011 1v1h14v-1a1 1 0 011-1h2a1 1 0 011 1v1h5v-6zm-9-6H17v2h14V9z"/></svg>
</template>
<script>

export default {
  name: 'IconJob',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
